






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { Policy } from '@/modules/Policy/interfaces/policy'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'

@Component({
  components: {
    AppSystemInfoCard
  }
})
export default class PolicyDetailAdditional extends Vue {
  @Prop({ type: Object as () => Policy }) readonly policy!: Policy
}
